(function(algolia) {
  'use strict';
  const englishLabelText = {
    search: 'Current search',
    noCollectionFound: 'No collection found',
    allProducts: 'See all products',
    matching: 'matching',
    sortBy: 'Sort by',
    filters: 'Filters',
    sortAndFilter: 'Sort & Filter',
    apply: 'Apply',
    relevance: 'Relevance',
    outOf: 'out of',
    resultFound: 'result found',
    resultsFor: 'Results for',
    resultsFound: 'results found',
    oneResultFound: '1 result found',
    noResultFound: 'No result found',
    for: 'for',
    addToCart: 'Add to cart',
    searchForProduct: 'Search for products',
    selectedFilter: 'Selected filters',
    clearAll: 'Clear all filters',
    noPageFound: 'No page found',
    outOfStock: 'Out of stock',
    createNow: "Create now"
  }

  const frenchLabelText = {
    search: 'Recherche en cours',
    noCollectionFound: 'Aucune collection trouvée',
    allProducts: 'Voir tous les produits',
    matching: 'adaptation',
    sortBy: 'Trié par',
    filters: 'Filtres',
    sortAndFilter: 'Trier et filtrer',
    apply: 'Appliquer',
    resultsFor: 'résultats pour',
    resultsFound: 'résultat trouvés',
    relevance: 'Pertinence',
    outOf: 'sur',
    resultsFound: 'résultats trouvés',
    oneResultFound: '1 résultat trouvé',
    noResultFound: 'Aucun résultat trouvé',
    for: 'pour',
    addToCart: 'Ajouter au panier',
    searchForProduct: 'Chercher des produits',
    selectedFilter: 'Filtres sélectionnés',
    clearAll: 'Effacer tout les filtres',
    noPageFound: 'Aucune page trouvée',
    outOfStock: 'En rupture de stock',
    createNow: 'Créer Maintenant'
  }

  const translations = Shopify.locale === "fr" ? frenchLabelText : englishLabelText;

  algolia.translations = {
    ...translations
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      if(Shopify.locale === "fr") {
        return 'Aucun résultat pour la ' + render(text);
      } else {
        return 'No result for ' + render(text);
      }
    },
    in: function() {
      if(Shopify.locale === "fr") {
        return 'dans ' + this.processingTimeMS / 1000 + 's';
      } else {
        return 'in ' + this.processingTimeMS / 1000 + 's';
      }
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      if(Shopify.locale === "fr") {
        return (
          'Essayez ' +
          render(html_tags[0]) +
          ' suppression des filtres ' +
          render(html_tags[1]) +
          ' ou ' +
          render(html_tags[2]) +
          ' modification de votre entrée ' +
          render(html_tags[3])
        );
      } else {
        return (
          'Try ' +
          render(html_tags[0]) +
          ' clearing filters ' +
          render(html_tags[1]) +
          ' or ' +
          render(html_tags[2]) +
          ' changing your input ' +
          render(html_tags[3])
        );
      }
    },

    outOf: function() {
      if(Shopify.locale === "fr") {
        return (
          this.page * this.hitsPerPage +
          1 +
          '-' +
          Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
          ' sur'
        );
      } else {
        return (
          this.page * this.hitsPerPage +
          1 +
          '-' +
          Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
          ' out of'
        );
      }
    },

    by: function(text, render) {
      if(Shopify.locale === "fr") {
        return 'par ' + render(text);
      } else {
        return 'by ' + render(text);
      }
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
